import React from "react";

// Admin Imports
import MainDashboard from "../views/user/default";
import Reports from "../views/user/reports";
import QuaterlyReports from "../views/user/reportsQuaterly";

import DataTables from "../views/user/financial-management";
import BudgetManagement from "../views/user/budget";
import Configuration from "../views/user/configuration";
// Icon Imports
import {
  MdHome,
  MdAttachMoney,       // Finance Management
  MdAccountBalance,     // Budget Management
  MdAssessment,         // Report
  MdSettings,           // Configuration
} from "react-icons/md";

const routes = [
  {
    name: "Página Inicial",
    layout: "/user",
    icon: <MdHome className="h-6 w-6" />,
    path: "default",
    component: <MainDashboard />,
  },
  {
    name: "Gestão Financeira",
    layout: "/user",
    icon: <MdAttachMoney className="h-6 w-6" />,
    path: "financial-mangement",
    component: <DataTables />,
  },
  {
    name: "Gestão Orçamentária",
    layout: "/user",
    path: "budget-mangement",
    icon: <MdAccountBalance className="h-6 w-6" />,
    component: <BudgetManagement />,
  },
  // {
  //   name: "Gestão Documentos",
  //   layout: "/admin",
  //   path: "document-mangement",
  //   icon: <MdDescription className="h-6 w-6" />,
  //   component: <DocumentManagement />,
  // },
  
  {
    name: "Relatórios",
    layout: "/user",
    path: "reports",
    icon: <MdAssessment className="h-6 w-6" />,
    component: <Reports />,
  },
  {
    name: "Relatório Trimestral",
    layout: "/user",
    path: "quaterly",
    icon: <MdAssessment className="h-6 w-6" />,
    component: <QuaterlyReports />,
  },
  {
    name: "Configuração",
    layout: "/user",
    path: "configuration-mangement",
    icon: <MdSettings className="h-6 w-6" />,
    component: <Configuration />,
  }

];
export default routes;
